/* Yaniko — астрономията зад астралната карта.

   Тази част е СМЕТКА, не гадаене: юлианска дата, звездно време, наклон на
   еклиптиката, асцендент по географска ширина. Същите формули, по които
   работят астрономическите справочници.

   Какво НЕ е сметка: кой камък на коя зодия отговаря. Това е традиция и
   текстовете на сайта го казват направо, вместо да се преструват.

   Точност: Слънце ~0.01°, Луна ~0.3°, асцендент ~0.05° — далеч под ширината
   на един знак (30°), тоест знакът излиза верен освен в първите секунди
   около границата. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.YGKAstro = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var RAD = Math.PI / 180;
  var DEG = 180 / Math.PI;

  var SIGNS = ['Овен', 'Телец', 'Близнаци', 'Рак', 'Лъв', 'Дева',
               'Везни', 'Скорпион', 'Стрелец', 'Козирог', 'Водолей', 'Риби'];

  function norm(d) { d = d % 360; return d < 0 ? d + 360 : d; }

  /* Знакът е просто дванадесета част от еклиптиката, броена от пролетната
     точка. Затова един и същ код върши работа за Слънце, Луна и асцендент. */
  function signOf(lon) {
    var i = Math.floor(norm(lon) / 30);
    return { index: i, name: SIGNS[i], degree: norm(lon) - i * 30 };
  }

  /* Юлианска дата от календарна дата в СВЕТОВНО време (UT). */
  function julianDay(y, m, d, hoursUT) {
    if (m <= 2) { y -= 1; m += 12; }
    var A = Math.floor(y / 100);
    var B = 2 - A + Math.floor(A / 4);       // грегориански календар
    return Math.floor(365.25 * (y + 4716)) +
           Math.floor(30.6001 * (m + 1)) +
           d + B - 1524.5 + hoursUT / 24;
  }

  /* България: UTC+2, лятно време +3 по правилото на ЕС — от последната неделя
     на март до последната неделя на октомври. Въведено е през 1979; за
     по-ранни рождени дати не се прилага. */
  function lastSunday(year, month) {
    var d = new Date(Date.UTC(year, month + 1, 0));   // последният ден на месеца
    return d.getUTCDate() - d.getUTCDay();
  }

  function bulgarianOffset(y, m, d, hourLocal) {
    if (y < 1979) return 2;
    var startDay = lastSunday(y, 2);   // март
    var endDay = lastSunday(y, 9);     // октомври
    var afterStart = (m > 3) || (m === 3 && (d > startDay || (d === startDay && hourLocal >= 3)));
    var beforeEnd = (m < 10) || (m === 10 && (d < endDay || (d === endDay && hourLocal < 4)));
    return (afterStart && beforeEnd) ? 3 : 2;
  }

  /* Средно звездно време в Гринуич, в градуси. */
  function gmst(jd) {
    var T = (jd - 2451545.0) / 36525;
    var g = 280.46061837 + 360.98564736629 * (jd - 2451545.0) +
            0.000387933 * T * T - (T * T * T) / 38710000;
    return norm(g);
  }

  function obliquity(jd) {
    var T = (jd - 2451545.0) / 36525;
    return 23.439291 - 0.0130042 * T - 0.00000016 * T * T + 0.000000504 * T * T * T;
  }

  /* Еклиптична дължина на Слънцето. */
  function sunLongitude(jd) {
    var n = jd - 2451545.0;
    var L = norm(280.460 + 0.9856474 * n);
    var g = norm(357.528 + 0.9856003 * n) * RAD;
    return norm(L + 1.915 * Math.sin(g) + 0.020 * Math.sin(2 * g));
  }

  /* Еклиптична дължина на Луната — съкратен ред, достатъчен за знак. */
  function moonLongitude(jd) {
    var n = jd - 2451545.0;
    var Lp = norm(218.316 + 13.176396 * n) * RAD;      // средна дължина
    var Mp = norm(134.963 + 13.064993 * n) * RAD;      // средна аномалия на Луната
    var D  = norm(297.850 + 12.190749 * n) * RAD;      // средна елонгация
    var M  = norm(357.529 + 0.985600 * n) * RAD;       // средна аномалия на Слънцето
    var F  = norm(93.272 + 13.229350 * n) * RAD;       // аргумент на ширината

    var lon = Lp * DEG
      + 6.289 * Math.sin(Mp)
      + 1.274 * Math.sin(2 * D - Mp)
      + 0.658 * Math.sin(2 * D)
      + 0.214 * Math.sin(2 * Mp)
      - 0.186 * Math.sin(M)
      - 0.114 * Math.sin(2 * F);
    return norm(lon);
  }

  /* Асцендентът: точката от еклиптиката, която изгрява на източния хоризонт
     в мига и мястото на раждане. Оттук идва и цялата разлика между двама души,
     родени в един ден — за два часа асцендентът сменя знака. */
  function ascendant(lstDeg, latDeg, eps) {
    var lst = lstDeg * RAD, lat = latDeg * RAD, e = eps * RAD;
    var y = Math.cos(lst);
    var x = -(Math.sin(lst) * Math.cos(e) + Math.tan(lat) * Math.sin(e));
    var asc = Math.atan2(y, x) * DEG;
    asc = norm(asc);
    // Асцендентът винаги е на изток от медиум цели — нормализацията по-горе
    // оставя стойността в правилния полукръг.
    return asc;
  }

  /* Пълната карта. Часът се подава в МЕСТНО време, часовата разлика се смята. */
  function chart(opts) {
    var y = opts.year, m = opts.month, d = opts.day;
    var hourLocal = opts.hour + (opts.minute || 0) / 60;

    var offset = bulgarianOffset(y, m, d, opts.hour);
    var hoursUT = hourLocal - offset;

    // Прехвърляне през полунощ, ако часовата разлика е изкарала датата назад.
    var jd = julianDay(y, m, d, hoursUT);

    var eps = obliquity(jd);
    var lst = norm(gmst(jd) + opts.lon);

    return {
      jd: jd,
      часова_разлика: offset,
      слънце: signOf(sunLongitude(jd)),
      луна: signOf(moonLongitude(jd)),
      асцендент: signOf(ascendant(lst, opts.lat, eps))
    };
  }

  return {
    chart: chart,
    signOf: signOf,
    SIGNS: SIGNS,
    _вътрешни: { julianDay: julianDay, gmst: gmst, sunLongitude: sunLongitude, moonLongitude: moonLongitude, ascendant: ascendant, obliquity: obliquity }
  };
}));
